import { useToggle } from '@vueuse/core'
import { computed, watch } from 'vue'
import { useUser } from '@/composables/auth.client'
import { useTagsQuery } from '~~/src/composables/query/tags/useTagsQuery'
import { useElementalTagsQuery } from '~~/src/composables/query/tags/useElementalTagsQuery'
import type { Elemental } from '~~/src/types/elemental'

export function useTagBox(elemental: Ref<Elemental | null>) {
  const user = useUser()
  const [open, toggleOpen] = useToggle()

  const productId = computed(() => elemental?.value?.id ?? '')
  const userId = computed(() => user.value?.id)

  const { data: allTags, isLoading: isLoadingUserTags, refetch } = useTagsQuery({
    userId,
  }, {
    enabled: computed(() => !!user.value?.id),
  })

  const { data: elementalTags, isLoading: isLoadingElementalTags, refetch: refetchElementalTags } = useElementalTagsQuery({
    elementalId: productId,
  }, {
    enable: computed(() => !!elemental?.value?.id),
  })

  watch(open, (openValue) => {
    if (openValue && !!elemental?.value?.id && !!user.value?.id) {
      refetch()
      refetchElementalTags()
    }
  })

  const isLoading = computed(() => isLoadingUserTags.value || isLoadingElementalTags.value)

  return {
    open,
    toggleOpen,
    isLoading,
    allTags,
    elementalTags,
    refetch,
    refetchElementalTags,
  }
}
